import { createApp } from "vue";
import App from "./App.vue";
/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faUserSecret);
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueCryptojs from "vue-cryptojs";
import Datepicker from "vue3-date-time-picker";
import "vue3-date-time-picker/dist/main.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Camera from "simple-vue-camera";

import "@/core/plugins/prismjs";
import "bootstrap";
import VueElementLoading from "vue-element-loading";
import VueMapboxTs from "vue-mapbox-ts";
import mitt from "mitt"; // Import mitt
const emitter = mitt();
const app = createApp(App);
app.component("VueElementLoading", VueElementLoading);
app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(VueSweetalert2);
app.use(VueCryptojs);
app.use(VueLoading);
app.component("camera", Camera);
app.component("font-awesome-icon", FontAwesomeIcon);
app.component("Datepicker", Datepicker);
app.component("v-select", vSelect);
ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();
app.use(VueMapboxTs);
app.use(i18n);

app.provide("emitter", emitter);
app.mount("#app");
